import { render, staticRenderFns } from "./SHHeader.vue?vue&type=template&id=6c6e8938&"
import script from "./SHHeader.vue?vue&type=script&lang=ts&"
export * from "./SHHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports